import script from "./SongRegistration.vue?vue&type=script&setup=true&lang=js"
export * from "./SongRegistration.vue?vue&type=script&setup=true&lang=js"

import "./SongRegistration.vue?vue&type=style&index=0&id=41360702&lang=css&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-41360702"]])

export default __exports__